import styled from '@emotion/styled';
import { Box, Flex } from '@qga/roo-ui/components';
import pluralize from 'pluralize';

import Heading from '@/components/Heading';
import Text from '@/components/Text';
import MapViewButton from '../../../MapViewButton';

interface PropertyOptionsHeaderProps {
  title: string;
  theme?: string;
  isPostSearch?: boolean;
  orderedPropertiesCount: number;
}

const Title = styled(Heading.h2)`
  scroll-margin-top: 1rem;
`;

const PropertyOptionsHeader = ({
  title,
  theme,
  isPostSearch,
  orderedPropertiesCount,
}: PropertyOptionsHeaderProps) => {
  const headingText =
    orderedPropertiesCount > 0
      ? `${title && `${title}`} ${theme ? '' : 'holidays'}`
      : 'No exact matches';

  const bodyText =
    orderedPropertiesCount > 0
      ? `Showing ${orderedPropertiesCount} ${pluralize('package', orderedPropertiesCount)}`
      : 'Try changing your travel dates.';

  const marginBottom = orderedPropertiesCount > 0 ? 0 : 4;

  return (
    <Flex
      flexDirection={['column', null, 'row']}
      mb={[marginBottom, null, marginBottom]}
    >
      <Flex flex="1" flexDirection="column" justifyContent="center">
        <Title
          id="destination-title"
          as="h2"
          pb="2"
          lineHeight="1.33"
          fontSize={['lg', null, '2xl']}
        >
          {headingText}
        </Title>
        {isPostSearch && <Text>{bodyText}</Text>}
      </Flex>
      {orderedPropertiesCount > 0 && (
        <Box pl={[null, null, '6']} mt={['6', null, '0']}>
          <MapViewButton />
        </Box>
      )}
    </Flex>
  );
};

export default PropertyOptionsHeader;
